module.exports = __webpack_public_path__ + "img/“.86f571f8.svg";